import configureStore from './configureStore'

let store

export const initStore = () => {
  store = configureStore()
}

export const getStore = () => store



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/store/index.js